import http from './http'

export default {
    all() {
        return http.get('leads-digitales')
    },
    update(lead, payload) {
        return http.put(`leads-digitales/${lead}`, payload)
    },
}